import { Radio as BaseRadio, styled } from "@material-ui/core";
import React from "react";

const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  border: "1px solid grey",
  borderRadius: "100rem",
  paddingRight: "1rem",
  transition:
    "border-color 0.2s ease-in-out, background-color 0.2s ease-in-out",
  "&[data-error=true]": {
    borderColor: "red",
    backgroundColor: "rgba(255, 0, 0, 0.1)",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

/** @deprecated potential-component */
export const Radio: FCwC<
  Omit<React.ComponentProps<typeof BaseRadio>, "onClick"> & {
    error?: boolean;
    onClick?: () => void;
  }
> = ({ children, error, onClick, ...delegateProps }) => {
  return (
    <Container data-error={error} onClick={onClick}>
      <BaseRadio {...delegateProps} />
      {children}
    </Container>
  );
};
